export default "__VITE_ASSET__42K02lDM__"